import React from 'react'
import classNames from 'classnames'

export const PoweredByAI = ({ className, margin = true }) => {
  return (
    <div className={classNames('small-text muted-text', { mb: margin }, className)}>
      Balto can make mistakes. Check important info.
    </div>
  )
}
